<!--
 * @Author: alownilow alownilow@163.com
 * @Date: 2023-08-31 13:49:45
 * @LastEditors: alownilow alownilow@163.com
 * @LastEditTime: 2026-09-03 12:30:00
 * @FilePath: \alownilow-web\src\views\home\HContent.vue
 * @Description:
 * alownilow@163.com
 *
-->
<template>
  <div class="page">
    <section class="hero" aria-label="首页">
      <div class="hero-media" aria-hidden="true">
        <img src="@/assets/back.jpg" alt="" class="hero-img" />
        <div class="hero-veil"></div>
      </div>

      <div class="hero-copy">
        <p class="brand">Alownilow</p>
        <h1 class="title">那天</h1>
        <p class="lede">
          吹过的风，走过的路，奔跑过的田野——都沉淀成淡淡的花香。
        </p>
        <a class="cta" href="#essay">读下去</a>
      </div>

      <a class="scroll-hint" href="#essay" aria-label="滚动阅读">
        <span class="scroll-line"></span>
      </a>
    </section>

    <article id="essay" class="essay">
      <header class="essay-head">
        <h2>那天</h2>
        <p>一段关于童年、故园与光阴的记忆</p>
      </header>

      <div class="essay-body">
        <p>
          世间最难忘的是童年，最怀念的是故园，最不舍的是光阴，岁月犹如一首青春之歌，一唱便没有回头路，往事如风，深深浅浅都已飘荡在日月的光辉之中，留下的是浅浅的记忆，淡淡的忧伤。
        </p>
        <p>
          五月的春风轻柔地拂过脸庞，多情的白云紧紧地贴着浩瀚的蓝天，秀逸俊廷的绿竹青榕，热情如火的一串红，给娴静的岭南印象园带来了春的生机，春的喜悦。
        </p>
        <p>
          走在熟悉的园林，看着尝过的锅巴、福饼、猫耳朵、鸡仔饼，用过的鱼篓、渔网、“风柜”，心里一股热流涌过，暖暖的，唤醒了沉睡中的记忆，我像个小孩一样痴痴地陶醉，静静地回味，似看到了故乡，似回到了童年。
        </p>
        <p>
          忆起了那段面朝黄土背朝天的时光，灼灼的烈日照着三个小小的身影，三个小人头顶戴着大大的草帽脚上穿着晃晃的水鞋，奔走在蜿蜒崎岖的五角田边沿，哥哥们走在前头，抬着重重的秧苗准备去插田，我走在后头兴歌起舞，“没有花儿香，没有树高，我是一棵无人知道的小草，从不寂寞，从不烦恼，你看我的伙伴遍及天涯海角，春风啊春风你把我吹绿，阳光啊阳光你把我照耀……”欢蹦乱跳，一个无忧无虑的野丫头，没有杂念没有忧愁，跟着哥哥们走在坑坑洼洼的小路插田干活去，一半是玩耍，一半是劳作。
        </p>
        <p>
          青葱的岁月，纯真的童年，忙碌的身影，一帘又一帘浮现在眼前。嘴角边不禁露出浅浅的笑颜，那一浅笑宛如天上虹。
        </p>
        <p>
          躲在屋子里的羊“咩”地一声惊醒了还沉醉在记忆中的我。缓过神来，离关园时间将近，眼前晃过稀稀两两的游客身影，还有三两个小孩在“快乐童年”玩泥沙，笼子里的鸟儿嘶嘶地叫，是快乐无忧的叫声，是欢喜淘气的叫声，窄窄的小道荡着一颗颗赤诚诚的心。仰起头来，掬一起夕晖，猛地抬起脚，像小时候一样，大步大步地走着走着，走向明天，走向远方。
        </p>
        <p>
          吹过的风，走过的路，踏过的桥，奔跑过的田野，都赴进时光中沉淀成淡淡的花香，芬芳往后岁月的每一时刻。
        </p>
        <p class="closing">
          那个不谙世事，从不寂寞，从不烦恼的丫头，如今已长大成人。童年虽逝，童心依旧，憧憬着激情四射的六月里的某一个日子，带着一颗明媚如初的心回到温柔的家乡。
        </p>
      </div>
    </article>
  </div>
</template>

<style lang="scss" scoped>
.page {
  --ink: #1c2228;
  --muted: #5a6570;
  --snow: #eef2f5;
  --paper: #f6f8fa;
  --accent: #3f5f6e;
  color: var(--ink);
  background: var(--paper);
}

.hero {
  position: relative;
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  align-items: flex-end;
  overflow: hidden;
  color: #f4f6f8;
}

.hero-media {
  position: absolute;
  inset: 0;
  z-index: 0;
}

.hero-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 42%;
  transform: scale(1.06);
  animation: drift 18s ease-in-out infinite alternate;
  filter: saturate(0.85) contrast(1.05);
}

.hero-veil {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(
      180deg,
      rgba(18, 24, 30, 0.18) 0%,
      rgba(18, 24, 30, 0.08) 38%,
      rgba(18, 24, 30, 0.55) 72%,
      rgba(18, 24, 30, 0.78) 100%
    ),
    radial-gradient(
      ellipse 80% 55% at 50% 20%,
      rgba(255, 255, 255, 0.12),
      transparent 70%
    );
}

.hero-copy {
  position: relative;
  z-index: 1;
  width: min(720px, calc(100% - 3rem));
  margin: 0 auto 18vh;
  text-align: center;
  animation: rise 1.1s cubic-bezier(0.22, 1, 0.36, 1) both;
}

.brand {
  margin: 0;
  font-family: "Fraunces", "Noto Serif SC", serif;
  font-size: clamp(3.2rem, 9vw, 6.5rem);
  font-weight: 500;
  letter-spacing: 0.04em;
  line-height: 0.95;
  text-shadow: 0 2px 30px rgba(0, 0, 0, 0.25);
}

.title {
  margin: 1.1rem 0 0;
  font-family: "Noto Serif SC", "Songti SC", serif;
  font-size: clamp(1.35rem, 2.8vw, 1.85rem);
  font-weight: 500;
  letter-spacing: 0.55em;
  text-indent: 0.55em;
  opacity: 0.92;
}

.lede {
  margin: 1.25rem auto 0;
  max-width: 28em;
  font-family: "Noto Serif SC", "Songti SC", serif;
  font-size: clamp(0.95rem, 1.8vw, 1.1rem);
  line-height: 1.85;
  color: rgba(244, 246, 248, 0.88);
  font-weight: 400;
}

.cta {
  display: inline-block;
  margin-top: 2rem;
  padding: 0.65rem 0;
  color: #f4f6f8;
  font-family: "Noto Serif SC", "Songti SC", serif;
  font-size: 0.95rem;
  letter-spacing: 0.28em;
  text-indent: 0.28em;
  text-decoration: none;
  border-bottom: 1px solid rgba(244, 246, 248, 0.55);
  transition: border-color 0.25s ease, opacity 0.25s ease;
}

.cta:hover {
  border-color: #f4f6f8;
  opacity: 0.9;
}

.scroll-hint {
  position: absolute;
  z-index: 1;
  left: 50%;
  bottom: 2.2rem;
  width: 1px;
  height: 42px;
  transform: translateX(-50%);
  text-decoration: none;
}

.scroll-line {
  display: block;
  width: 1px;
  height: 100%;
  background: linear-gradient(
    180deg,
    rgba(244, 246, 248, 0),
    rgba(244, 246, 248, 0.85)
  );
  animation: pulse 2.2s ease-in-out infinite;
}

.essay {
  width: min(680px, calc(100% - 2.5rem));
  margin: 0 auto;
  padding: clamp(4rem, 10vw, 7rem) 0 5rem;
}

.essay-head {
  margin-bottom: 2.75rem;
  text-align: center;

  h2 {
    margin: 0;
    font-family: "Noto Serif SC", "Songti SC", serif;
    font-size: clamp(1.6rem, 3vw, 2rem);
    font-weight: 500;
    letter-spacing: 0.4em;
    text-indent: 0.4em;
  }

  p {
    margin: 0.85rem 0 0;
    color: var(--muted);
    font-family: "Noto Serif SC", "Songti SC", serif;
    font-size: 0.95rem;
    letter-spacing: 0.08em;
  }
}

.essay-body {
  p {
    margin: 0 0 1.45rem;
    font-family: "Noto Serif SC", "Songti SC", serif;
    font-size: clamp(1rem, 1.5vw, 1.08rem);
    line-height: 2;
    text-align: justify;
    text-justify: inter-ideograph;
    color: var(--ink);
  }

  .closing {
    margin-top: 2.25rem;
    padding-top: 1.75rem;
    border-top: 1px solid rgba(28, 34, 40, 0.12);
    color: var(--accent);
  }
}

@keyframes drift {
  from {
    transform: scale(1.06) translate3d(0, 0, 0);
  }
  to {
    transform: scale(1.12) translate3d(0, -1.2%, 0);
  }
}

@keyframes rise {
  from {
    opacity: 0;
    transform: translateY(28px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pulse {
  0%,
  100% {
    opacity: 0.35;
    transform: scaleY(0.85);
    transform-origin: top;
  }
  50% {
    opacity: 1;
    transform: scaleY(1);
    transform-origin: top;
  }
}

@media (max-width: 640px) {
  .hero-copy {
    margin-bottom: 16vh;
    width: calc(100% - 2rem);
  }

  .brand {
    letter-spacing: 0.02em;
  }

  .title {
    letter-spacing: 0.4em;
    text-indent: 0.4em;
  }

  .essay-body p {
    text-align: left;
  }
}

@media (prefers-reduced-motion: reduce) {
  .hero-img,
  .hero-copy,
  .scroll-line {
    animation: none;
  }

  .hero-img {
    transform: scale(1.04);
  }
}
</style>
